import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import componentStyles from './Card.css';

const SimpleCard = props => {
  const { classes } = props;

  return (
    <div>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <Typography className={classes.title} color="textSecondary">
            {props.title}
          </Typography>
          <Typography className={classes.highlight} variant="title">
            {props.highlight}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(componentStyles)(SimpleCard);



// WEBPACK FOOTER //
// ./src/views/ViewCustomerCase/Card/Card.jsx